import LayoutField from "common/Form/CFormlayout";
import MonthRangePicker from "common/Form/CMonthRangePicker";

export const fields = {
  layout_grid: LayoutField,
  monthRangePicker: MonthRangePicker,
};
export default fields;
